export default "__VITE_ASSET__6c0489a4__"